import React, { PropsWithChildren } from "react";
import {
  ViewStyle,
  StyleSheet,
  ScrollView,
  ScrollViewProps,
} from "react-native";
import { sizes } from "assets/constants";

const ScrollLayout: React.FC<PropsWithChildren<ScrollViewProps>> = ({
  children,
  ...props
}) => {
  return (
    <ScrollView
      {...props}
      keyboardShouldPersistTaps="always"
      showsVerticalScrollIndicator={false}
      contentContainerStyle={{
        ...styles.containerStyles,
        ...(props.contentContainerStyle as ViewStyle),
      }}
    >
      {children}
    </ScrollView>
  );
};

export default ScrollLayout;

const styles = StyleSheet.create({
  containerStyles: { flexGrow: 1, padding: sizes.space },
});
